export default "__VITE_ASSET__Bx6uhmRs__"